"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
});
const normalizePrice = (frequency, cents) => {
    if (!cents)
        return 0;
    return frequency === 'year' ? cents / 12 : cents;
};
const formatPrice = (cents) => {
    return cents ? formatter.format(cents / 100) : null;
};
const PriceDisplay = ({ product, frequency, billedLabel, className = '' }) => {
    const formattedPrice = formatPrice(normalizePrice(frequency, product.priceInCents));
    const formattedNonDiscountedPrice = formatPrice(normalizePrice(frequency, product.nonDiscountedPriceInCents));
    return (React.createElement("section", { className: `price-section sui-flex sui-justify-start sui-items-center ${className}` },
        React.createElement("div", { className: "price" },
            formattedPrice === '$10.00' ? '$9.99' : formattedPrice,
            " / mo"),
        formattedNonDiscountedPrice != null && (React.createElement("div", { className: "price-small sui-ml-1" },
            React.createElement("span", { className: "price-small__currency sui-line-through" }, formattedNonDiscountedPrice))),
        React.createElement("div", { className: "price-small sui-ml-1" },
            React.createElement("span", { className: "price-small__currency" }, "USD"),
            " ",
            billedLabel)));
};
exports.default = PriceDisplay;
